export function leadsLink(value) {
  return process.env.REACT_APP_ENV === 'development'
    ? `http://localhost:3105/${value}?preview=true`
    : `${document.location.origin.replace(
        'admin',
        'leads'
      )}/${value}?preview=true`
}
